export default {
  loading: false,
  schemaDetails: {},
  schemaList: {},
  periodicity: {},
};



// WEBPACK FOOTER //
// ./node_modules/@intelipost-modules/secure-capacity-management/features/schema/store/state.js